import Swal from 'sweetalert2'
import Dropzone from 'dropzone'

import { imageHtml } from './imageHtml'
import {
  handleDataOfDelay,
  handleOldDataOfDelay,
  sweetAlertCommonParams,
} from '../../functions/utils'
import { lang } from '../../assets/lang'

// eslint-disable-next-line
export const imageModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.image_modal_title,
    html: imageHtml,
    willOpen: () => {
      const fileUploadMediaUrlElement = $('#file-upload-media-url')
      fileUploadMediaUrlElement.val(oldData.file || '')

      let serverGeneratedFilename = ''
      Dropzone.autoDiscover = false
      window.flowBuilderUploadedFile = {}
      var base_url = window.xitFlowBuilderData.base_url

      // eslint-disable-next-line
      const uploadImgDropzone = new Dropzone("#file-upload-dropzone", {
        url: base_url+'visual_flow_builder/flow_builder_upload_media',
        maxFilesize: 5,
        uploadMultiple: false,
        paramName: "media_file",
        createImageThumbnails: true,
        acceptedFiles: ".png, .jpg, .jpeg, .gif, .JPEG, .JPG, .PNG, .GIF",
        maxFiles: 1,
        addRemoveLinks: true,

        // eslint-disable-next-line
        success: async function(file, response) {
          // Display message if error
          if (false === response.status) {
            await Swal.fire({
              icon: 'error',
              text: response.message,
              title: 'Error!',
            });

            return
          }

          if (response.status) {
            serverGeneratedFilename = response.file
            window.flowBuilderUploadedFile = {
              file: response.file
            }

            fileUploadMediaUrlElement.val(response.file)
          }
        },

        // eslint-disable-next-line
        removedfile: function(file) {
          if (window.flowBuilderUploadedFile.file === serverGeneratedFilename) {
            // eslint-disable-next-line
            const result = deleteUploadedFile(serverGeneratedFilename)
              .then(response => {
                if (response.status) {
                  window.flowBuilderUploadedFile = {}
                  fileUploadMediaUrlElement.val('')
                  $('#file-upload-dropzone .dz-preview').remove()
                  Dropzone.forElement('#file-upload-dropzone').removeAllFiles(true)
                }
              }).catch(error => {
                if (error.status !== '200' && error.statusText) {
                  const message = error.status + ' ' + error.statusText
                  alert(message)
                } else {
                  console.log(error)
                }
              })
          }
        },
      })

      const deleteUploadedFile = async (file) => {
        return await $.ajax({
          type: 'POST',
          url: base_url+'visual_flow_builder/flow_builder_delete_media',
          dataType: 'JSON',
          data: { file }, 
        })
      }

      // Handles old data of Delay
      handleOldDataOfDelay(oldData)

      // Removes previous files if there is any
      Dropzone.forElement('#file-upload-dropzone').removeAllFiles(true)
    },

    preConfirm: () => {
      const fileData = window.flowBuilderUploadedFile
      const uploadedUrl = $('#file-upload-media-url').val()
  
      if ((0 === Object.values(fileData).length) && node.data.file) {
        fileData.file = node.data.file
      }
      
      if (uploadedUrl) {
        fileData.file = uploadedUrl
      }
      
      if (! uploadedUrl && (Object.values(fileData).length !== 1)) {
        Swal.showValidationMessage(lang.image_modal_msg_image)
      }
    
      const delayData = handleDataOfDelay()

      return {
        ...fileData,
        ...delayData,
      }
    },    
  })
}